import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthState } from '@app/infrastructure/authentication/auth.state';
import { Store } from '@ngxs/store';

export const isAuthenticatedGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  if (store.selectSnapshot(AuthState.isAuthenticated)) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
